import React, { useState } from 'react';
import { db } from '../../firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';
import { GRADOS } from '../../constants';

// --- Componente para agregar estudiantes ---
export default function AddStudent({ user, currentYear }) {
    const [nombreCompleto, setNombreCompleto] = useState('');
    const [documentoIdentidad, setDocumentoIdentidad] = useState('');
    const [grado, setGrado] = useState(GRADOS[0]);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setIsSubmitting(true);

        if (!nombreCompleto.trim() || !documentoIdentidad.trim()) {
            setError("El nombre y el documento son obligatorios.");
            setIsSubmitting(false);
            return;
        }

        try {
            await addDoc(collection(db, "estudiantes"), {
                nombreCompleto,
                documentoIdentidad,
                grado,
                profesorId: user.uid,
                year: currentYear // Save with the currently selected year
            });
            setMessage('¡Estudiante agregado exitosamente!');
            setNombreCompleto('');
            setDocumentoIdentidad('');
            // Optional: reset grade? setGrado(GRADOS[0]);
        } catch (err) {
            setError('Error al agregar estudiante: ' + err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="glass-card p-8 rounded-2xl mb-8 animate-fade-in">
            <h2 className="text-2xl font-bold mb-6 text-slate-800 bg-clip-text text-transparent bg-gradient-to-r from-primary-600 to-secondary-600">
                Agregar Nuevo Estudiante ({currentYear})
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div className="lg:col-span-1">
                        <label className="block text-slate-600 font-semibold mb-2">Nombre Completo</label>
                        <input
                            type="text"
                            value={nombreCompleto}
                            onChange={(e) => setNombreCompleto(e.target.value)}
                            className="glass-input w-full px-4 py-3 rounded-xl"
                            placeholder="Ej: Juan Pérez"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-slate-600 font-semibold mb-2">Documento de Identidad</label>
                        <input
                            type="text"
                            value={documentoIdentidad}
                            onChange={(e) => setDocumentoIdentidad(e.target.value)}
                            className="glass-input w-full px-4 py-3 rounded-xl"
                            placeholder="Ej: 12345678"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-slate-600 font-semibold mb-2">Grado</label>
                        <select
                            value={grado}
                            onChange={(e) => setGrado(e.target.value)}
                            className="glass-input w-full px-4 py-3 rounded-xl"
                        >
                            {GRADOS.map(g => <option key={g} value={g}>{g}</option>)}
                        </select>
                    </div>
                </div>
                <div className="flex justify-end">
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="btn-primary px-8 py-3 rounded-xl font-bold disabled:opacity-70 flex items-center gap-2"
                    >
                        {isSubmitting ? 'Guardando...' : 'Agregar Estudiante'}
                    </button>
                </div>
            </form>
            {message && <div className="mt-6 p-4 rounded-xl bg-green-50 border border-green-100 text-green-600 font-medium animate-pulse">{message}</div>}
            {error && <div className="mt-6 p-4 rounded-xl bg-red-50 border border-red-100 text-red-600 font-medium animate-pulse">{error}</div>}
        </div>
    );
}
